import 'echarts-gl';
import * as echarts from 'echarts';
import china from '../json/china.json';
import { setMap3D, setGeo, setGeo3D, setIcons, setLines, setScatter, formatRegions } from '../tools';

const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'AeMap3D',
  props: {
    id: { type: String, default: () => (`a-e-map-3d-${Math.random().toString().substring(2)}`) },
    delay: { type: Number, default: () => 0 },
    area: { type: String, default: () => '' },
    site: { type: String, default: () => '' },
    data: { type: Array, default: () => [] },
    zoom: { type: Number | String, default: () => 1.2 },
    config: { type: Object, default: () => ({}) },
    background: { type: String, default: () => '#ccc' },
  },
  data() {
    return {
      scale: this.zoom,
      charts: null,
      option: null,
      regions: null,
      siteIcon: require('./image/3d.png'),
    }
  },
  mounted() {
    this.create();
  },
  beforeDestroy() {
    this.cancel();
  },
  methods: {
    create() {
      let area = this.area != '' ? JSON.parse(this.area) : china;
      if (area != '') {
        echarts.registerMap(this.id, area);
        this.regions = formatRegions(area, this.background);
        let sites = [];
        this.data.map(a => {
          this.regions.map(b => {
            if ((a.stationLocation.city == b.name) || (b.name.includes(a.stationLocation.city))) {
              sites.push({ ...b, ...a });
            }
          });
        });
        this.option = {
          geo3D: setGeo3D(this.id, this.regions),
          series: [
            // setMap3D(this.id, this.regions),
          ],
          ...this.config,
        }
      }
    },
    action(charts, option) {
      if (charts) {
        this.charts = charts;
        if (this.regions && this.regions.length > 0) {
          this.charts.off('click');
          this.charts.on('click', region => {
            let area = region.region || region.data || null;
            this.regions.forEach(a => {
              a.selected = false;
              if (area && (a.id == area.id)) a.selected = !area.selected;
            });
            this.select(area);
          });
          this.charts.off('georoam');
          this.charts.on('georoam', ({ zoom }) => zoom && (this.scale = Number((this.scale * zoom.toFixed(1)).toFixed(1))));
          (option && option.geo && option.geo.zoom) ? option.geo.zoom = this.scale : () => null;
        }
      }
    },
    select(a) {
      this.$emit('select', a && !a.selected && a);
    },
    cancel() {
      if (this.charts) {
        echarts.dispose(this.charts);
        this.charts.dispose();
        this.charts.clear();
        this.charts = null;
      }
    },
  },
  render() {
    const { width = '100%', height = '80vh' } = this.$attrs;
    return (<Aecharts type="map" width={width} height={height} option={this.option} on-action={this.action} />);
  }
}